import { createContext, useContext } from "react";
const FieldsetContext = /*#__PURE__*/ createContext(void 0);
const useFieldsetContext = ()=>useContext(FieldsetContext);
export { FieldsetContext, useFieldsetContext };
